import { logSentryWarning } from '@mews/framework';

export const initializeAssetLoaders =
    () =>
    async (dispatch: $TSFixMe, _getState: $TSFixMe, { platformImageAssetLoader }: $TSFixMe) => {
        try {
            await platformImageAssetLoader.initialize();
        } catch (error) {
            dispatch(
                logSentryWarning({
                    error,
                    extra: {
                        step: 'INIT_ASSET_LOADER',
                    },
                })
            );
        }
    };
